'use client';

import type { FunctionComponent } from 'react';

interface ClearChatButtonProps {
  clearing: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const ClearChatButton: FunctionComponent<ClearChatButtonProps> = ({
  clearing,
  disabled,
  onClick,
}) => (
  <button
    type="button"
    className="inline-flex h-7 w-7 items-center justify-center rounded-[6px] border border-transparent bg-transparent text-ink-3 transition-colors hover:border-line-2 hover:bg-bg-hover hover:text-ink disabled:cursor-not-allowed disabled:opacity-40"
    onClick={onClick}
    disabled={disabled || clearing}
    aria-label="Clear chat"
    title="Clear chat"
  >
    {clearing ? (
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        className="animate-spin"
        aria-hidden
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    ) : (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M3 6h18" />
        <path d="M8 6V4h8v2" />
        <path d="M19 6l-1 14H6L5 6" />
        <path d="M10 11v5" />
        <path d="M14 11v5" />
      </svg>
    )}
  </button>
);
